<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr } from '../../../common/util';
  import { currentSelectedStoreData, giftCardAmount, giftvalidemail, productDetailMainData } from '../store/pdp_store';
  const { pageTemplate } = getAppConfig();

  import PdpButton from './PdpButton.svelte';
  import PdpQuantityModifier from './PdpQuantityModifier.svelte';
  export let data = null;

  let dispatcher = createEventDispatcher();

  $: cfsSelectedStoreData = $currentSelectedStoreData;

  // For add to cart button
  $: stockStatus = data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock';

  let disablePreOrderBtn;

  /**
   * Calculates the flag to disable the pre-order button based on the stock levels.
   */
  $: {
    const { cfsBackOrderEligible, cfsBackOrderLaunchDate, homeDeliveryData, isCollectFromStoreEnabled } = data || {};

    // Check if backorder is eligible and launch date is available and isCollectFromStoreEnabled is true
    if (cfsBackOrderEligible && cfsBackOrderLaunchDate && isCollectFromStoreEnabled) {
      // enable button
      disablePreOrderBtn = false;
    }
    // If home delivery is out of stock, disable the button
    else if (homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'outOfStock') {
      disablePreOrderBtn = true;
    }
    // Default case: button enabled
    else {
      disablePreOrderBtn = false;
    }
  }
  $: deliveryInStock =
    data?.homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'inStock' ||
    data?.homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'lowStock';
  $: cfsInStock =
    cfsSelectedStoreData?.stockLevelStatus?.code === 'inStock' ||
    cfsSelectedStoreData?.stockLevelStatus?.code === 'lowStock';
  $: stockcheckfor1P = deliveryInStock || cfsInStock;

  $: disabledFlag = $productDetailMainData.isMarketPlaceProduct
    ? !stockStatus
    : data?.isAddToCartGrayedOut ||
      (data?.digitalDeliveryItem && !data?.isDigitalGiftCard
        ? false
        : !(stockStatus && stockcheckfor1P) ||
          (data?.isDigitalGiftCard &&
            (!$giftvalidemail ||
              !$giftCardAmount ||
              $giftCardAmount < data?.minGiftCardAmount ||
              $giftCardAmount > data?.maxGiftCardAmount)));

  function addToCart() {
    dispatcher('addToCart', null);
  }
</script>

{#if pageTemplate !== 'extraPreOrderLandingPageTemplate'}
  <PdpQuantityModifier displayQtyModifier={data?.productStatus === 'PRE_ORDER' ? !disablePreOrderBtn : !disabledFlag} />
{/if}
<div class="add-to-cart-wrapper {data?.isDigitalGiftCard ? 'mrb-3' : ''}">
  {#if (data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock') && data?.productStatus === 'PRE_ORDER'}
    <div class="preorder-btn-wrapper">
      <PdpButton
        label={getStr('extra.preorderbutton')}
        type="secondary"
        variant="solid"
        size="large"
        disabled={disablePreOrderBtn}
        productCode={data?.productCode}
        on:click={() => addToCart()}
      />
    </div>
  {:else if data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock'}
    <div class="main-button-wrapper">
      <div class="add-to-cart-action">
        <PdpButton
          label={getStr('extra.addtocartbutton')}
          type="secondary"
          variant="solid"
          size="large"
          disabled={disabledFlag}
          productCode={data?.productCode}
          on:click={() => addToCart()}
        />
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .add-to-cart-wrapper {
    .main-button-wrapper {
      display: grid;
      gap: 8px;
      @include desktop-max-width {
        grid-template-columns: 100%;
        grid-template-areas: 'AddToCart';
      }
      @include desktop-min-width {
        gap: 20px;
      }
      .add-to-cart-action {
        @include desktop-max-width {
          grid-area: AddToCart;
        }
      }
    }
  }
</style>
